/* eslint-disable import/prefer-default-export */
const prefix = 'categories'

export const SET_CATEGORIES = `${prefix}/SET_CATEGORIES`
